var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4291 0.594971H6.84924C5.26316 0.594971 3.97249 1.88564 3.97249 3.47172C3.97249 3.72388 3.76807 3.9283 3.51591 3.9283C1.92983 3.9283 0.63916 5.21897 0.63916 6.80505V14.3848C0.63916 15.971 1.92983 17.2616 3.51591 17.2616H11.0957C12.3812 17.2616 13.4626 16.4107 13.8277 15.2442C13.9122 14.9739 14.1459 14.7616 14.429 14.7616C16.0152 14.7616 17.3058 13.471 17.3058 11.8849V3.47172C17.3058 1.88564 16.0152 0.594971 14.4291 0.594971ZM15.6392 11.8849C15.6392 12.5521 15.0963 13.095 14.4291 13.095C14.1769 13.095 13.9725 12.8906 13.9725 12.6384V6.80505C13.9725 5.21897 12.6818 3.9283 11.0957 3.9283H6.09574C5.84358 3.9283 5.63916 3.72388 5.63916 3.47172C5.63916 2.80447 6.18199 2.26164 6.84924 2.26164H14.429C15.0963 2.26164 15.6392 2.80447 15.6392 3.47172V11.8849Z",
    fill: "url(#paint0_linear_22_5799)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_5799",
    x1: 4.73187,
    y1: 3.68429,
    x2: 22.2736,
    y2: 21.7601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04D493"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8552F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d1b026d5b6fc3b935597184a01d2c7ee.svg";
export { ForwardRef as ReactComponent };